import {Label} from "../../../basic/label";
import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";
import {VwpUser} from "../../../../store/generated/api.ts";
import LicenseChip from "../../../shared/selectors/LicenseChip";

interface LicenseManagerProps {
    selectedUser: VwpUser | null;
    onRemoveLicense: (licenseId: string) => void;
}

export function LicenseManager({selectedUser, onRemoveLicense}: LicenseManagerProps) {
    const {t} = useTranslationWithKeys();
    const hasLicenses = selectedUser?.licenses && selectedUser.licenses.length > 0;

    return (
        <div className="space-y-2">
            <Label>{t('admin.users.editUser.assignedLicenses')}</Label>
            {hasLicenses ? (
                <div className="flex flex-wrap gap-2 p-3 rounded-lg border bg-muted/30">
                    {selectedUser?.licenses.map((license, idx) => (
                        <LicenseChip
                            key={idx}
                            productName={license.product}
                            licenseId={license.id}
                            variant="normal"
                            onRemove={() => onRemoveLicense(license.id)}
                        />
                    ))}
                </div>
            ) : (
                <div className="p-3 rounded-lg border bg-muted/30">
                    <span className="text-muted-foreground">{t('admin.users.editUser.noLicenses')}</span>
                </div>
            )}
            <p className="text-muted-foreground">
                {t('admin.users.editUser.licenseManagementNote')}
            </p>
        </div>
    );
}